/* Copyright (C) 2019 ASYX International B.V. All rights reserved. */

const actionTypes = {
    UPDATE_NOTIFICATION_LIST: 'UPDATE_NOTIFICATION_LIST',
    UPDATE_FULL_NOTIFICATION_LIST: 'UPDATE_FULL_NOTIFICATION_LIST',
    SET_TENANT_ID: 'SET_TENANT_ID',
    UPDATE_TASK_DOCUMENT: 'UPDATE_TASK_DOCUMENT',
    UPDATE_TASK_DOCUMENT_CLEAR: 'UPDATE_TASK_DOCUMENT_CLEAR',
    CHANGE_PAGE_TASK_DOCUMENT: 'CHANGE_PAGE_TASK_DOCUMENT',
    CHANGE_PAGE_TASK_DOCUMENT_CLEAR: 'CHANGE_PAGE_TASK_DOCUMENT_CLEAR',
    CANCEL_TASK_DOCUMENT: 'CANCEL_TASK_DOCUMENT',
    CANCEL_TASK_DOCUMENT_CLEAR: 'CANCEL_TASK_DOCUMENT_CLEAR',
    ADD_REPORT_ENGINE: 'ADD_REPORT_ENGINE',
    UPDATE_REPORT_ENGINE: 'UPDATE_REPORT_ENGINE',
    DELETE_REPORT_ENGINE: 'DELETE_REPORT_ENGINE',
    GET_TIMEZONE_LIST: 'GET_TIMEZONE_LIST',
    GET_SUPPORTED_CURRENCIES: 'GET_SUPPORTED_CURRENCIES',
    SET_LOGO: 'SET_LOGO',
    SET_PAGE_ERROR: 'SET_PAGE_ERROR',
    ORG_INFO_IS_COMPLETE: 'ORG_INFO_IS_COMPLETE',
    UNPAID_BILLING: 'UNPAID_BILLING',
    UNPAID_INVOICES: 'UNPAID_INVOICES',
    CLEAR_UNPAID_INVOICES: 'CLEAR_UNPAID_INVOICES',
    PROMPT_OTP: 'PROMPT_OTP',
    SET_OTP_CONFIGURATION: 'SET_OTP_CONFIGURATION',
    RESET_OTP_CONFIGURATION: 'RESET_OTP_CONFIGURATION',
};

export default actionTypes;
